import "./instrument";

import i18n from "i18next";
import Backend from "i18next-http-backend";
import React from "react";
import ReactDOM from "react-dom/client";
import { initReactI18next } from "react-i18next";
import { BrowserRouter } from "react-router-dom";

import { utmStorage } from "@/lib/storage/utm";

import App from "./App";
import "./index.css";
import { GoogleOAuthProvider } from "@react-oauth/google";

import { GOOGLE_CLIENT_ID } from "@/config";

import { SentryUserContext } from "./lib/sentry";
import { AnalyticsProvider } from "./providers/AnalyticsProvider";
import { InitAppAuth } from "./providers/InitAppAuth";
import { TanstackQueryProvider } from "./providers/TanstackQueryProvider";

utmStorage.captureFromUrl(window.location.search);

i18n
  .use(Backend)
  .use(initReactI18next)
  .init({
    lng: "en",
    fallbackLng: "en",
    ns: [],
    defaultNS: false,
    interpolation: {
      prefix: "{",
      suffix: "}",
      escapeValue: false,
    },
    backend: {
      loadPath: "/locales/{{lng}}/{{ns}}.json",
    },
  });

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
      <TanstackQueryProvider>
        <InitAppAuth>
          <SentryUserContext />
          <BrowserRouter>
            <AnalyticsProvider>
              <App />
            </AnalyticsProvider>
          </BrowserRouter>
        </InitAppAuth>
      </TanstackQueryProvider>
    </GoogleOAuthProvider>
  </React.StrictMode>,
);
